import DocumentHeader from '@components/DocumentHeader';
import {
  ROUTE_USER_REGISTER,
  ROUTE_ACCOUNT_RECOVERY,
} from '@/constants/routes';
import SkyscraperBackground from '@components/SkyscraperBackground';
import { useOTP } from '@/hooks/useLogin';
import { Heading, Text } from '@simplywallst/ui-core';
import { Container, Link } from './styled';

function AuthenticationStatus() {
  const otp = useOTP();

  if (otp.status === 'pending') {
    return (
      <>
        <Heading as="h2" color="black">
          One-time password login
        </Heading>
        <Container>
          <Text data-cy-id="error-message" typography="small" color="black">
            Logging you in...
          </Text>
        </Container>
      </>
    );
  }

  if (otp.status === 'error') {
    if (otp.type === 'stale') {
      return (
        <>
          <Heading as="h2" color="black">
            Account validation
          </Heading>
          <Container>
            <Text data-cy-id="error-message" typography="small" color="black">
              It appears that your account has become stale. Please recreate
              your account.
            </Text>
          </Container>
          <Link to={{ type: ROUTE_USER_REGISTER }}>Register</Link>
        </>
      );
    }
    return (
      <>
        <Heading as="h2" color="black">
          One-time password login
        </Heading>
        <Container>
          <Text data-cy-id="error-message" typography="small" color="black">
            {otp.message || 'An unknown error has occurred.'}
          </Text>
        </Container>
        <Link to={{ type: ROUTE_ACCOUNT_RECOVERY }}>Recover my account</Link>
      </>
    );
  }

  return null;
}

export function OTPLogin() {
  return (
    <SkyscraperBackground>
      <DocumentHeader title="One-time password login" allowCrawlers={false} />
      <AuthenticationStatus />
    </SkyscraperBackground>
  );
}
